<template>
  <!-- <div>
    <OverlayPanel ref="statute" :breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '680px'}">
        Test
    </OverlayPanel>
    </div> -->

  <!-- COUNT -->
  <td class="fs-6c" :class="{
    'border-top ': !hideBorderTop,
    'py-0 px-0 p-0': chg.CrimeTypeId == 6 || chg.CrimeTypeId == 2,
    'py-4 pl-5 pr-0': chg.CrimeTypeId == 5 || chg.CrimeTypeId == 1 || chg.CrimeTypeId == 3,
    'border-left': showBorderLeft,
    'bg-primary': !showBorderLeft,
    'border-bottom': isLastChargeInCharges && chg.CrimeTypeId !== 6 && chg.CrimeTypeId !== 2
  }
  ">
    <!-- <input
        type="number"
        name="count"
        style="width: 30px; background-color: transparent; border: none"
        
        @change="changeCountNumber(charge, $event)"
        v-model="this.chg.CountNumber"
        /> -->
        <span class="" v-if="chg.CrimeTypeId == 5">{{ chg.CountNumber }}</span>
        <!-- <div class="p-relative" v-else-if="chg.CrimeTypeId == 6 || chg.CrimeTypeId == 2">
          <span class="l-shape"></span>
        </div> -->
  </td>

  <!-- Crime Type -->
  <td
    :class="isLastChargeInCharges ? 'border-bottom' : ''"  v-if="detailedView" class="border-top  fs-5 py-4 fs-6c">
    <span
      style="text-align: center"
      class="d-flex justify-content-center mt-2"
      v-if="chg.CrimeTypeId == 5"
      >Crime</span
    >
    <span
      style="text-align: center"
      class="d-flex justify-content-center mt-2"
      v-if="chg.CrimeTypeId == 1"
      >SE</span
    >
    <span
      style="text-align: center"
      class="d-flex justify-content-center mt-2"
      v-if="chg.CrimeTypeId == 6"
      >CE</span
    >
    <span
      style="text-align: center"
      class="d-flex justify-content-center mt-2"
      v-if="chg.CrimeTypeId == 3"
      >PA</span
    >
  </td>

  <!-- STATUTE -->
  <td :class="{
    'enhancement-count-td': chg.CrimeTypeId == 6 || chg.CrimeTypeId == 2,
    'border-bottom': isLastChargeInCharges
  }" class="border-top  py-4 fs-6c pl-3 fs-5">
    <!-- i FOR STATUTE -->

    <div class="p-0" style="z-index: 4">
      <!-- <span v-if="chg.CrimeState == 'Attempt'">
        PC 664/
      </span>
      <span v-if="chg.CrimeState == 'Conspiracy'">
        PC 182/
      </span> -->
      <span class="p-0">
        <!-- {{ chg.codeDefinitionCode }} -->
        <!-- <span v-if="chg?.CPSectionNumber !== chg.SectionNumber">
                        {{ chg?.CPSectionNumber }} 
                        {{ (chg.CPSectionNumber ?? '').length > 0?'/':'' }}
                    </span> -->
        {{ chg.SectionNumber }}
      </span>
    </div>
  </td>

  <!-- FOR NAME (DESCRIPTION) -->
  <td
    
    :class="isLastChargeInCharges ? 'border-bottom' : ''"
    class="border-top fs-5 py-4 pl-0 fs-6c"
    style="overflow: hidden; white-space: nowrap"
  >
    <!-- <i
      :class="detailedView ? '' : 'big-book'"
        class="border-top  fa fa-info-circle book_auth float-left mr-3"
        data-section="InfoSection2"
        data-field="StatuteColumn"
        @click="
          emitPopupText({
            header: 'Elements',
            body: chg.Elements,
          })
        "
      ></i> -->
    <span
      v-if="
        chg.CrimeState == 'Attempt' &&
        !chg.Name.includes('Attempted', 0)
      "
    >
      Attempt -
    </span>
    <span v-if="chg.CrimeState == 'Conspiracy'">
      Conspiracy -
    </span>
    {{ chg.Name }}

    <!-- <i
      :class="detailedView ? '' : 'big-book'"
        class="border-top  fa-solid fa-circle-question float-right mr-4 book_auth mt-2 ml-3"
        v-if="chg?.ChargedPer"
        @click="toggleCPKPicker"
      ></i> -->

    <!-- <i class="border-top  fa fa-info-circle book_auth float-left" data-section="InfoSection2" data-field="StatuteColumn" 
                    @click="showLawText2(chg.Name, chg.Elements, dt(chg.Date).format( `YYYY-MM-DD`) , chg)"></i> -->

    <!-- <i
            class="border-top  fa fa-info-circle book_auth float-left"
            data-section="InfoSection2"
            data-field="StatuteColumn"
            @click="
                displayLawText({
                view: 'VCrimes',
                column: 'Elements',
                refColumn: 'Id',
                groupInfo: {
                    table: 'VCrimes',
                    filterCol: 'SectionNumber',
                    filterVal: chg.SectionNumber,
                    returnCols:      'Id, SectionNumber as Section, Name, BeginDate, EndDate, date_posted as Posted',
                    orderBy: 'BeginDate desc'
                    
                },
                title: `More Description for ${chg.codeDefinitionCode} ${chg.SectionNumber}`,
                })
            "
            ></i> -->
  </td>
  <!-- OFFENSE DATE -->
  <td 
    :class="isLastChargeInCharges ? 'border-bottom' : ''" v-if="detailedView" class="border-top  py-4  pl-0">
    <!-- <input
    class="border-top  form-control mt-0 mb-0 pr-0 pl-2 bg-transparent border-0 "
    type="date"
    :value="dt.utc(chg.Date).format('YYYY-MM-DD')"
    title="Date notes and more description goes here"
    id="example-date-local-input"
    style="width: 82px"
  /> -->
    <span
      class="d-flex align-items-center justify-content-center"
      :class="chg?.DateRangeEnd ? 'h-50' : 'mt-2'"
    >
      {{ dt.utc(chg.Date).format("M/D/YYYY") }}
    </span>

    <span
      class="d-flex align-items-center justify-content-center"
      v-if="chg?.DateRangeEnd"
    >
      <!-- <br /> -->
      {{ dt.utc(chg.DateRangeEnd).format("M/D/YYYY") }}</span
    >
  </td>
  <!-- SEVERITY -->
  <td 
    :class="isLastChargeInCharges ? 'border-bottom' : ''" class="border-top  py-4 pl-0">
    <div class="m-0 p-0 fs-5 d-flex justify-content-start">
      <!-- <select
      
    :class="isLastChargeInCharges ? 'border-bottom' : ''"
        class="btn btn-sm border-0 p-0 form-control-sm fs-6c "
        id="inputGroupSelect01"
        style="width: 70px"
        v-if="chg.WobbleDirection !== 0"
        @input="wobble(chg)"
      >
        <option
          v-if="
            chg.CrimeSeverityName == 'Felony' ||
            (chg.CrimeSeverityName == 'Misdemeanor' && chg.WobbleDirection == 1)
          "
          class="text-left"
          value="3"
          :selected="chg.CrimeSeverityName == 'Felony'"
        >
          Felony
        </option>
        <option
          class="text-left"
          value="2"
          :selected="chg.CrimeSeverityName == 'Misdemeanor'"
        >
          Misd
        </option>
        <option
          class="text-left"
          value="1"
          v-if="
            chg.CrimeSeverityName == 'Infraction' ||
            (chg.CrimeSeverityName == 'Misdemeanor' && chg.WobbleDirection == 2)
          "
          :selected="chg.CrimeSeverityName == 'Infraction'"
        >
          Inf
        </option>
      </select> -->
      <span class=" ">{{
        chg.CrimeSeverityName == "Felony" ? "Felony" : chg.CrimeSeverityName.substring(0, 4)
      }}</span>
    </div>
  </td>
  <!-- STATUS -->
  <td
    
    :class="isLastChargeInCharges ? 'border-bottom' : ''"
    v-if="detailedView"
    class="border-top  m-0 p-0 pt-1 pl-0 fs-6c"
  >
    <select
      class="btn btn-sm mt-0 border-0 p-0 form-control-sm fs-6c float-left"
      id="inputGroupSelect01"
      style="width: 82px; display: block"
      @input="chargeStatusChange($event, chg)"
      v-model="this.chg.ChargeStatus"
    >
      <option value="0" :selected="chg.ChargeStatus == '0'">Convicted</option>
      <option value="1" :selected="chg.ChargeStatus == '1'">Acquitted</option>
      <option value="2" :selected="chg.ChargeStatus == '2'">Dismissed</option>
      <option value="3" :selected="chg.ChargeStatus == '3'">Stayed 654</option>
      <option
        v-if="chg.ChargeStatus == '4'"
        value="4"
        :selected="chg.ChargeStatus == '4'"
      >
        Stayed
      </option>
      <option v-else value="6" :selected="chg.ChargeStatus == '6'">Stayed</option>
    </select>
  </td>

  <!-- PRINCIPAL -->
  <td
    
    :class="isLastChargeInCharges ? 'border-bottom' : ''"
    v-if="detailedView"
    class="border-top  py-0 m-0 d-lg-table-cell fs-6c px-0 mx-0"
  >
    <!-- <div class="border-top  wrapper w-ps-2"> -->

    <div class="p-0 m-0">
     
      <span
        v-if="principalTies?.length > 1 && principalTies.includes(chg.CountNumber)"
        class="border-top  d-flex flex-column align-items-center"
      >
        <span class="p-0 fs-6c">PC 1170.1</span>
        
      </span>
      <span
        class="fs-6c pl-2 d-flex flex-column align-items-center"
        v-else-if="chg.newExposureObject?.isPrincipal == 0"
        ><span class="p-0 fs-6c">PC 1170.1</span> Subord</span
      >
      <span
        class="fs-6c pl-2 d-flex flex-column align-items-center"
        v-else-if="chg.newExposureObject?.isPrincipal == 1"
      >
        <span class="p-0 fs-6c">PC 1170.1</span>Principal</span
      >
      <span
        class="fs-6c pl-2 d-flex flex-column align-items-center"
        v-else-if="chg?.newExposureObject?.isPrincipal == 2 && !chg?.isGang"
        >PC 669</span
      >
      <span
        class="fs-6c pl-2 d-flex flex-column align-items-center"
        v-else-if="chg?.newExposureObject?.isPrincipal == 2 && chg?.isGang"
        >PC 186.22(b)</span
      >
      <span
        class="fs-6c pl-2 d-flex flex-column align-items-center"
        v-else-if="chg?.newExposureObject?.isPrincipal == 3"
        >{{ chg.SectionNumber }}</span
      >
      <span
        class="fs-6c pl-2 d-flex flex-column align-items-center"
        v-else-if="chg?.newExposureObject?.isPrincipal == 4"
        >PC 18.5</span
      >
      <span
        class="fs-6c pl-2 d-flex flex-column align-items-center"
        v-else-if="chg?.newExposureObject?.isPrincipal == 6"
        >PC 667.6
      </span>
    </div>

    <!-- <div class="border-top  background">
            <i
            class="border-top  fa fa-info-circle book_auth float-left"
            data-section="InfoSection2"
            data-field="StatuteColumn"
            ></i>
        </div> -->
    <!-- </div> -->
  </td>
  <td
    v-if="detailedView"
    :class="isLastChargeInCharges ? 'border-bottom' : ''"
    class="border-top  py-0 m-0 d-lg-table-cell fs-6c px-0 mx-0"
  >
    <div class="mt-2 p-0 m-0 d-flex justify-content-center">
      <button
        class="btn btn-primary"
        @click="toggleRunStirCalculation(chg)"
        v-if="
          chg.SubordinateSTIRFactor !== 3 &&
          (chg.newExposureObject?.isPrincipal == 0 ||
            chg.newExposureObject?.isPrincipal == 6 ||
            (chg.newExposureObject?.isPrincipal == 1 && chg.CrimeCategoryId == 26))
        "
      >
        <span v-if="chg.RunSTIRCalculation">Full </span>
        <span v-else><sup>1</sup>&frasl;<sub>3</sub> </span>
        <span v-if="chg.SubordinateSTIRTerm == 3"> Term</span>
        <span v-else> Middle</span>
      </button>
      <span
        style="width: 90px; text-align: center"
        v-else-if="chg.newExposureObject?.isPrincipal == 0"
      >
        <span v-if="chg.newExposureObject?.isPrincipal == 0 && chg.CrimeTypeId == 5"
          ><sup>1</sup>&frasl;<sub>3</sub> Middle</span
        >
        <span v-else-if="chg.newExposureObject?.isPrincipal == 0 && chg.CrimeTypeId == 6">
          <span
            v-if="
              chg?.parentCharge?.RunSTIRCalculation !== true ||
              chg?.parentCharge?.EnhancementSTIRFactor === 3
            "
          >
            <sup>1</sup>&frasl;<sub>3</sub> Term
          </span>
          <span v-else>Full Term</span>
        </span>
        <span v-else>Full Term</span>
      </span>
      <span style="width: 90px; text-align: center" v-else>Term</span>
    </div>
  </td>
</template>

<script>
import moment from "moment";
import SC from "../../components/utils/sharedComponent.vue";
// import OverlayPanel from "primevue/overlaypanel";
import axios from "axios";
import { handleError } from "../../helpers";
export default {
  props: [
    "chg",
    "toggleView",
    "app_attr",
    "app_token",
    "principalTies",
    "charges",
    "detailedView",
    "hideBorderTop",
    "showBorderLeft"
  ],
  components: { SC },
  data() {
    return {
      dt: moment,
      reanimate: true,
      charge: this.chg,
      // crime: {
      //   DefinitionStatuteId: -1,
      //   codeDefinitionId: -1,
      //   sectionNumber: "",
      //   sectionSubSection: "",
      //   sectionId: -1,
      // },
      DefinitionStatuteList: [{ a: 1, b: 2 }],
      StatuteList: [],
      currentCountNumber: null,
    };
  },

  methods: {
    chargeStatusChange($event, chg) {
      const val = parseInt($event.target.value, 10);
      this.chg.ChargeStatus = val;

      this.postChargeField(chg.Id, "ChargeStatus", val);

      this.$emit("chargeStatusChange", {
        chg: this.chg,
        origin: this.$options,
      });
    },

    toggleCPKPicker() {
      this.$emit("selectedCharge", this.chg);
      // console.log("CPK PICKER");
      this.$emit("toggleCPKPicker");
    },

    async toggleRunStirCalculation(chg) {
      if (!chg?.RunSTIRCalculation) {
        chg.RunSTIRCalculation = true;
      } else {
        chg.RunSTIRCalculation = false;
      }
      this.postChargeField(chg.Id, "RunSTIRCalculation", chg.RunSTIRCalculation);
    },

    async postChargeField(Id, field, e) {
      let this_app_token = this.app_token;

      let value = e.target?.value || e;
      // console.log("Id>>>", Id);

      SC.postChargeField(this_app_token, Id, field, value);
      this.$emit("onCalc");
    },

    emitPopupText(obj) {
      this.$emit("displayModalPopup", obj);
    },
    
    changeCountNumber(charge, count) {
      const newCount = count.target.value;
      // this.$emit('changeCountNumber', charge, count)
      // console.log(newCount);
      const prevCount = this.currentCountNumber;
      let existingCountIndex = this.charges.data.findIndex(
        (chg) =>
          chg.CountNumber == newCount && chg.CrimeTypeId == 5 && chg.Id !== this.chg.Id
      );
      // console.log(existingCountIndex);
      if (existingCountIndex > -1) {
        // console.log("BAD NUMBER");
        if (newCount > prevCount) {
          this.chg.CountNumber++;
        } else {
          this.chg.CountNumber--;
        }
      } else {
        this.$emit("onCalc");
        // console.log("OKAY COUNT NUMBER");
      }
    },
  },
  computed: {
    isLastChargeInCharges(){
      return this.charges.data[this.charges.data.length - 1].Id == this.chg.Id
    },
  },
  async created() {},
  watch: {},
  mounted() {
    // console.log("this.toggleView:::", this.toggleView);
    this.currentCountNumber = this.chg.CountNumber;
  },
};
</script>

<style scoped>
.w-details {
  font-size: 10px;
  font-weight: bold;
  padding-top: 2px;
  width: 50px !important;
  white-space: nowrap;
}

.br-0 {
  border-radius: 0;
}

.w-details-date {
  font-size: 10px;
  font-weight: bold;
  padding-top: 2px;
  white-space: nowrap;
}

.w-details-td {
  white-space: nowrap;
}

::-webkit-calendar-picker-indicator {
  margin-left: -15px;
}

.fs-8 {
  font-size: 14px;
}

.text-align-center {
  text-align: center;
}

.enhancement-count-td {
  border-left: 1px solid var(--border) !important;

}

.l-shape {
  padding: 1rem;
  width: 70px;
  position: absolute;
  top: 0;
  left: 1.25rem;
  border-left: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
}

.p-relative {
  position: relative;
  min-height: 50px;
  width: calc(70px + 1.25rem);
  margin-top: -5px;
}

.bg-primary {
  background-color: var(--primary) !important;
}
.bg-primary:hover {
  background-color: var(--primary) !important;
}

</style>
